import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FullScreenButton from '@components/fullScreenButton';
import { addProtocolToLink } from '@utils/common';
import { getValueFromSearchParam } from '@utils/history';
import { FixedRatioSectionWrapper } from '@components/fixedRatioContainer';
import SharePointIframe from '@components/sharePointDisplay/SharePointIframe';
import useCustomizedModuleData from '@hooks/useCustomizedModuleData';

const FullScreenElemId = 'iframe-pdf-container';

function IntegrationIframePage({ history, location, extraButton = null }) {
  // const dispatch = useDispatch();
  const projectId = useSelector((state) => state.common.currentId);
  // const link = getdecodeUrl(base64Link);
  const [showInFullScreen, setShowInFullScreen] = useState(false);
  const { integrationModuleId, moduleValue, M365 } = getValueFromSearchParam(
    'integrationModuleId',
    'moduleValue',
    'M365',
  );

  const [loading, toggleLoading] = useState(false);
  // const [ratioLoading, toggleRatioLoading] = useState(false);
  // const [sizeRatio, setSizeRatio] = useState();
  // const [sizeData, setSizeData] = useState();
  // const [ratioBtn, toggleRatioBtn] = useState(false);
  // const projectPermission = useSelector(
  //   (state) => state.common.projectCompanyInfo?.currentUserPermission,
  // );
  // const isClient = useSelector(
  //   ({ login }) => login.userInfo.role === USER_ROLE_MODEL.CLIENT,
  // );
  // const userName = useSelector((state) => state.login.userInfo.name);
  // const { link, ratio } = useCustomizedModuleFinder(moduleValue);
  const {
    targetModuleData: { link, ratio },
    // integrationModuleData,
  } = useCustomizedModuleData(moduleValue, integrationModuleId);

  const getIframeContainerElem = () =>
    document.getElementById(FullScreenElemId);

  const fullScreenHandler = () => {
    if (!document.fullscreenElement) {
      setShowInFullScreen(false);
    }
  };

  const addFullScreenEventListener = (elem) => {
    elem.addEventListener('fullscreenchange', fullScreenHandler);
  };

  const removeFullScreenEventListener = (elem) => {
    elem.removeEventListener('fullscreenchange', fullScreenHandler);
  };

  // const fetchRatioData = async () => {
  //   toggleRatioLoading(true);
  //   toggleLoading(true);
  //   const res = await dispatch(actions.getProjectSetting(projectId));
  //   setSizeData(res);
  //   for (const module in res.moduleInfo) {
  //     if (res.moduleInfo[module].module === moduleName) {
  //       if (res.moduleInfo[module].ratio)
  //         setSizeRatio(res.moduleInfo[module].ratio);
  //       else setSizeRatio('64:27');
  //     }
  //   }
  //   toggleLoading(false);
  //   toggleRatioLoading(false);
  // };

  // const generateFormData = (value, res) => {
  //   const data = {
  //     clientSetting: res.clientInfo,
  //     moduleSetting: res.moduleInfo,
  //     projectSetting: res.projectInfo,
  //     teamSetting: res.teamInfo,
  //   };
  //   for (const module in data.moduleSetting) {
  //     if (data.moduleSetting[module].module === moduleName) {
  //       data.moduleSetting[module].ratio = value;
  //     }
  //   }
  //   data.teamSetting.operatorName = userName;
  //   return data;
  // };

  // const handleRatioChange = async (value) => {
  //   toggleRatioLoading(true);
  //   toggleLoading(true);
  //   const formData = generateFormData(value, sizeData);
  //   //handle when is a project module
  //   const result = await dispatch(actions.saveProjectSettings(formData));
  //   //TODO: result works but has error
  //   // console.log(result);
  //   setSizeRatio(value);
  //   toggleLoading(false);
  //   toggleRatioLoading(false);
  // };

  // useEffect(() => {
  //   dispatch(
  //     actions.addBreadCrumb([
  //       {
  //         breadcrumbName: moduleName,
  //         path: `/link`,
  //       },
  //     ]),
  //   );
  // }, [moduleName]);

  // useEffect(() => {
  //   if (!isClient && projectPermission != projectRole['View-Only'])
  //     toggleRatioBtn(true);
  // }, [isClient, projectPermission]);

  useEffect(() => {
    const iFContainerElem = getIframeContainerElem();
    if (!iFContainerElem) {
      return () => {};
    }
    addFullScreenEventListener(iFContainerElem);
    return () => removeFullScreenEventListener(iFContainerElem);
  }, []);

  // useEffect(() => {
  //   fetchRatioData();
  // }, [projectId, link]);

  return (
    <div className="page-wrapper integration-iframe-page">
      <div className="integration-iframe-head">
        <span
          className="dd-back-btn"
          onClick={() => {
            history.replace(`/project-detail/${projectId}`, {
              preventRefresh: true,
              integrationModuleId,
            });
          }}
        >
          <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
        </span>
        <div className="integration-iframe-head-right">
          {/* {ratioBtn && (
            <div>
              Report Ratio
              <Select
                style={{
                  width: 150,
                  marginRight: 10,
                  marginLeft: 10,
                  background: '#2C2C2C',
                }}
                value={sizeRatio}
                loading={ratioLoading}
                options={[
                  { value: '16:9', label: 'Standard Size' },
                  { value: '32:7', label: 'Banner Size' },
                  { value: '64:27', label: 'Full Size' },
                ]}
                onSelect={handleRatioChange}
              />
            </div>
          )} */}
          {extraButton}
          <FullScreenButton elemId={`#${FullScreenElemId}`} />
        </div>
      </div>
      <FixedRatioSectionWrapper
        id={FullScreenElemId}
        ratio={ratio}
        className={`${showInFullScreen ? 'full-screen' : ''}`}
      >
        {Boolean(link) && link && !loading ? (
          M365 ? (
            <SharePointIframe link={link} />
          ) : (
            <iframe title="inte-iframe" src={addProtocolToLink(link)} />
          )
        ) : null}
      </FixedRatioSectionWrapper>
    </div>
  );
}

export default React.memo(IntegrationIframePage);
